const values = [
  {
    icon: 'ri-shield-check-line',
    title: 'Výsledky pred estetikou',
    desc: 'Krásny web, ktorý nepredáva, je len drahá galéria. Navrhujem tak, aby každý element slúžil jednej veci - konverzii.',
    color: 'from-orange-500/10 to-transparent',
    border: 'border-orange-500/20',
    tag: '#01',
  },
  {
    icon: 'ri-eye-line',
    title: 'Radikálna transparentnosť',
    desc: 'Žiadne skryté poplatky, žiadne nafúknuté reporty. Vieš presne čo platíš a čo za to dostávaš. Vždy.',
    color: 'from-amber-500/10 to-transparent',
    border: 'border-amber-500/20',
    tag: '#02',
  },
  {
    icon: 'ri-time-line',
    title: 'Rýchlosť ako záväzok',
    desc: 'Agentúry, ktoré dodávajú o 3 mesiace neskôr, ťa stáli príjmy. Nastavený som inak - termíny sú pre mňa zákon.',
    color: 'from-rose-500/10 to-transparent',
    border: 'border-rose-500/20',
    tag: '#03',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Partnerstvo, nie dodávateľstvo',
    desc: 'Nepíšem len faktúry. Sledujem čísla aj po odovzdaní, upozorním ťa, ak vidím príležitosť a navrhnem čo robiť.',
    color: 'from-emerald-500/10 to-transparent',
    border: 'border-emerald-500/20',
    tag: '#04',
  },
  {
    icon: 'ri-code-s-slash-line',
    title: 'Remeslo s presnosťou',
    desc: 'Každý riadok kódu, každý pixel, každá kampaň prechádza mojou kontrolou. Priemernosť u mňa nemá miesto.',
    color: 'from-cyan-500/10 to-transparent',
    border: 'border-cyan-500/20',
    tag: '#05',
  },
  {
    icon: 'ri-heart-line',
    title: 'Slovensko v DNA',
    desc: 'Som lokálny špecialista s globálnymi znalosťami. 15+ rokov v IT mi dalo prehľad, ktorý ťažko nájdeš u niekoho, kto len "robí weby". Poznám slovenský trh a zákazníka - a to je moja výhoda.',
    color: 'from-violet-500/10 to-transparent',
    border: 'border-violet-500/20',
    tag: '#06',
  },
];

export default function AboutValues() {
  return (
    <section className="bg-zinc-900/30 py-24 border-t border-zinc-800/50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-orange-400 text-xs uppercase tracking-widest font-semibold mb-3">Čím sa riadim</p>
          <h2 className="text-4xl md:text-5xl font-black text-white leading-tight mb-5">
            Moje hodnoty nie sú<br />na plagáte v kancelárii
          </h2>
          <p className="text-zinc-500 text-base leading-relaxed">
            Každé rozhodnutie, každý projekt, každý email - riadi sa týmito princípmi.
            Nie preto, že to vyzerá dobre. Preto, že to funguje.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {values.map((v) => (
            <div
              key={v.tag}
              className={`relative bg-gradient-to-br ${v.color} border ${v.border} rounded-2xl p-7 group hover:scale-[1.015] transition-all duration-300 overflow-hidden`}
            >
              {/* Tag */}
              <span className="absolute top-5 right-5 text-zinc-700 font-mono text-xs">{v.tag}</span>

              {/* Icon */}
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-zinc-800/80 border border-zinc-700/50 mb-5 group-hover:border-zinc-600 transition-colors duration-300">
                <i className={`${v.icon} text-orange-400 text-lg`} />
              </div>

              <h3 className="text-white font-bold text-lg mb-3 leading-snug">{v.title}</h3>
              <p className="text-zinc-500 text-sm leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
